//Include all needed js files
require( './bootstrap' );
require( './custom' );
require( './header' );
require( './sliders' );
require( './faq' );
require( './play-demo' );
require( './registration-form' );
require( './table' );
require( './scroll-top' );
require( './show-more' );